<template>
  <div>
    <CartItemsList />
    <div class="cart-footer">
      <div class="footer-layout css-2vxg6l e25lf6d0">
        <div class="css-15vhhhd e25lf6d1">
          <div class="css-esow25 e25lf6d3">
            <div class="css-15py5ir e25lf6d2">
              <span color="#001325" class="css-1um1mkq e171rb9k3 font-2"
                >₹{{ totalPrice }}</span
              >
            </div>
            <div class="css-1myqv6q e25lf6d5">
              <strong color="#001325" class="css-1lxsyb2 e171rb9k3"
                >Grand Total</strong
              >
              <span class="css-175whwo ehes2bo0">
                <svg
                  viewBox="0 0 24 24"
                  color="rgba(0, 19, 37, 0.64)"
                  class="css-irk0pp"
                >
                  <title></title>
                  <path
                    d="M12 4.5C13.4834 4.5 14.9334 4.93987 16.1668 5.76398C17.4001 6.58809 18.3614 7.75943 18.9291 9.12987C19.4968 10.5003 19.6453 12.0083 19.3559 13.4632C19.0665 14.918 18.3522 16.2544 17.3033 17.3033C16.2544 18.3522 14.918 19.0665 13.4632 19.3559C12.0083 19.6453 10.5003 19.4968 9.12988 18.9291C7.75943 18.3614 6.58809 17.4001 5.76398 16.1668C4.93987 14.9334 4.5 13.4834 4.5 12C4.5 10.0109 5.29018 8.10322 6.6967 6.6967C8.10323 5.29018 10.0109 4.5 12 4.5ZM12 3C10.22 3 8.47991 3.52784 6.99987 4.51677C5.51983 5.50571 4.36628 6.91131 3.68509 8.55585C3.0039 10.2004 2.82567 12.01 3.17294 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89472 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.387 3 12 3Z"
                    fill="#001325"
                    fill-opacity="0.92"
                  ></path>
                  <path
                    d="M11.15 8C11.14 7.83011 11.1812 7.66113 11.2683 7.51493C11.3554 7.36873 11.4844 7.25205 11.6386 7.17998C11.7928 7.10791 11.965 7.08378 12.133 7.11071C12.3011 7.13764 12.4572 7.21439 12.5811 7.33103C12.705 7.44767 12.7911 7.59882 12.8281 7.76492C12.8652 7.93102 12.8515 8.10442 12.7889 8.26267C12.7263 8.42092 12.6177 8.55673 12.477 8.65253C12.3364 8.74833 12.1702 8.79971 12 8.8C11.7815 8.80541 11.5698 8.72444 11.4106 8.57466C11.2515 8.42489 11.1578 8.21839 11.15 8Z"
                    fill="#001325"
                    fill-opacity="0.92"
                  ></path>
                  <path
                    d="M12 16.55C11.8019 16.5474 11.6126 16.4676 11.4725 16.3275C11.3324 16.1874 11.2526 15.9981 11.25 15.8V11.8C11.25 11.6011 11.329 11.4103 11.4697 11.2697C11.6103 11.129 11.8011 11.05 12 11.05C12.1989 11.05 12.3897 11.129 12.5303 11.2697C12.671 11.4103 12.75 11.6011 12.75 11.8V15.8C12.7474 15.9981 12.6676 16.1874 12.5275 16.3275C12.3874 16.4676 12.1981 16.5474 12 16.55Z"
                    fill="#001325"
                    fill-opacity="0.92"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
        </div>
        <div
          class="css-18zwcko e25lf6d8"
          @click="checkout"
          v-if="totalPrice != 0 && !isLoggedIn"
          >
          <!-- v-if="totalPrice != 0 && !isLoggedIn" -->
          <button class="css-f1qhpj e8tshxd0">
            <div class="css-15vhhhd e25lf6d4">
              <div class="css-207d6f e25lf6d7">
                <span class="css-1l4d0ex e171rb9k3">Proceed</span>
                <span class="css-1nh9xit e171rb9k3"></span>
              </div>
              <span class="css-1aowomc ehes2bo0">
                <i class="fa fa-arrow-right"></i>
              </span>
            </div>
          </button>
        </div>
        <div
          class="css-18zwcko e25lf6d8"
          v-else-if="totalPrice != 0 "
          @click="checkout"
          >
          <!-- v-if="totalPrice != 0 && !isLoggedIn" -->
          <button class="css-f1qhpj e8tshxd0">
            <div class="css-15vhhhd e25lf6d4">
              <div class="css-207d6f e25lf6d7">
                <span class="css-1l4d0ex e171rb9k3">Proceed</span>
                <span class="css-1nh9xit e171rb9k3"></span>
              </div>
              <span class="css-1aowomc ehes2bo0">
                <i class="fa fa-arrow-right"></i>
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "@/stores/cart";
import { ref, computed } from "vue";
import { useUserStore } from "@/stores/userStore";
import eventBus from "@/utils/eventBus";
import CartItemsList from "../common/CartItemsList.vue";
const userStore = useUserStore();
export default {
  components: {
    CartItemsList,
  },
  watch:{
    $route(){
      this.closeCart();
    }
  },
  setup() {
    const cartStore = useCartStore();
    const isLoggedIn = computed(() => userStore.isLoggedIn);
    let cartItems = computed(() => cartStore.cartItems);
    let totalPrice = computed(() => cartStore.totalPrice);
    let totalQuantity = computed(() => cartStore.totalQuantity);
    // onMounted(()=>{
    //   if(!(useCartStore()?.items?.length>0) && !!isLoggedIn.value){
    //     alert('mounted')
    //     useCartStore().clearCart();
    //     useCartStore().fetchCart();
    //   }
    // })
    const removeItem = (productId) => {
      cartStore.removeFromCart(productId);
    };

    const availableQuantities = [1, 2, 3, 4, "5+"];
    const customQuantity = ref(null);
    const dropdowns = ref({});

    const toggleDropdown = (productId) => {
      dropdowns.value[productId] = !dropdowns.value[productId];
    };

    const isDropdownOpen = (productId) => {
      return dropdowns.value[productId] || false;
    };

    const showCustomQuantity = ref(false);

    const updateQuantity = (productId, quantity) => {
      if (quantity === "5+") {
        showCustomQuantity.value = true;
      } else {
        showCustomQuantity.value = false;
        cartStore.updateQuantity(productId, quantity);
        dropdowns.value[productId] = false; // Close dropdown after selection
      }
    };

    return {
      isLoggedIn,
      cartItems,
      totalPrice,
      totalQuantity,
      availableQuantities,
      customQuantity,
      removeItem,
      toggleDropdown,
      isDropdownOpen,
      updateQuantity,
      showCustomQuantity,
    };
  },
  methods: {
    checkout() {
      this.closeCart();
      if (eventBus.toggleModal && !this.isLoggedIn) {
        eventBus.toggleModal();
        this.closeCart();
      } else {
        this.$router.push({ path: "/cart" });
      }
    },
    closeCart() {
      if(eventBus.panelClose){
        eventBus.panelClose();
      }
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .delete-product {
    left: calc(14px + 33vw) !important;
  }
}
.delete-product {
  position: relative;
  top: 30px;
  left: calc(10vw - 0px);
  width: fit-content;
  background: none;
  border: none;
}
.font-2 {
  font-family: "Raleway", sans-serif;
}
.dropdown-menu {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  z-index: 1000;
}

.dropdown-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-menu li {
  padding: 5px 10px;
  cursor: pointer;
}

.dropdown-menu li:hover {
  background-color: #f0f0f0;
}

.cart-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
}

.cart-drawer {
  position: fixed;
  top: 0;
  right: -100%;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 233200;
  transition: right 0.3s ease;
}

.cart-drawer.open {
  right: 0;
}

@media (min-width: 1024px) {
  .cart-drawer {
    width: 30%;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .cart-drawer {
    width: 50%;
  }
}

.cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.cart-content {
  height: 78vh;
  overflow-y: auto;
  padding: 20px;
}

.cart-items {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  padding-left: 12px;
}

.cart-item {
  background-color: rgb(255, 255, 255);
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 19, 37, 0.08);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  min-width: 100%;
}

.item-details {
  display: flex;
  text-align: left;
  flex-direction: column;
  margin-left: 15px;
}

.checkout-btn {
  background-color: #002f6c;
  color: white;
  padding: 10px 15px;
  width: 100%;
  border: none;
  border-radius: 5px;
}

.view-cart-btn {
  background-color: transparent;
  color: #002f6c;
  padding: 10px 15px;
  width: 100%;
  border: none;
  margin-top: 10px;
}

.css-2vxg6l {
  display: flex;
  flex-direction: row;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(0, 19, 37, 0.08);
  background: rgb(255, 255, 255);
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  height: 60px;
}

.css-15vhhhd {
  display: flex;
  flex-direction: row;
  -webkit-box-pack: justify;
  justify-content: space-between;
  width: 100%;
}

.css-esow25 {
  display: flex;
  flex-direction: column;
  padding: 4px 10px 4px 20px;
  -webkit-box-pack: justify;
  justify-content: space-between;
  width: 100%;
}

.css-15py5ir {
  display: flex;
  flex-direction: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  text-align: left;
  padding-top: 8px;
}

.css-1um1mkq {
  color: rgb(0, 19, 37);
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.1px;
  margin: unset;
}

.css-1myqv6q {
  display: flex;
  text-wrap: nowrap;
  flex-direction: row;
  padding-bottom: 5px;
}

.css-1lxsyb2 {
  color: rgb(0, 19, 37);
  font-size: 12px;
  /*  font-weight: 400; */
  line-height: 16px;
  letter-spacing: 0px;
  margin: unset;
}

.css-175whwo {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  cursor: pointer;
}

.css-18zwcko {
  display: flex;
  flex-direction: column;
  padding: 8px 20px 8px 10px;
  width: 100%;
}

.css-f1qhpj {
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding: 12px;
  border-style: solid;
  border-width: 1px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  border-color: rgb(0 48 108);
  background-color: rgb(0 48 108);
  color: rgb(255, 255, 255);
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  width: 100%;
  gap: 3px;
}

.css-18zwcko button {
  padding: 0px 12px;
  height: 50px;
  width: 200px;
}

.css-15vhhhd {
  display: flex;
  flex-direction: row;
  -webkit-box-pack: justify;
  justify-content: space-between;
  width: 100%;
}

.css-207d6f {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.css-1l4d0ex {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.1px;
  margin: unset;
}

.css-1nh9xit {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  margin: unset;
}

.css-1aowomc {
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
}
</style>
